import { LicenseManager } from 'ag-charts-enterprise'

import GU_AG_CHARTS_LICENSE_KEY from './guAgChartsLicense.js'

export function setLicenseKey (licenseKey = GU_AG_CHARTS_LICENSE_KEY) {
  LicenseManager.setLicenseKey(licenseKey)
  return licenseKey
}
